import React, { useState } from 'react';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { db } from '../../src/firebaseConfig'; 
import logo from '../assets/logo.png';
import './PasswordRecovery.css';

function PasswordRecovery() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [type, setType] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

const handleReset = async (e) => {
  e.preventDefault();
  setLoading(true);
  setMessage('');
  setType('');

  try {
    // Buscar en Firestore si el email existe
    const usuariosRef = collection(db, 'Usuarios');
    const q = query(usuariosRef, where('email', '==', email));
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      setMessage('No hay ninguna cuenta registrada con este correo.');
      setType('error');
      setLoading(false);
      return;
    }

    // Si existe, enviar el enlace
    const auth = getAuth();
    await sendPasswordResetEmail(auth, email);
    setMessage('Se ha enviado un enlace de recuperación a tu correo.');
    setType('success');
  } catch (error) {
    console.error(error);
    setMessage('Ocurrió un error al enviar el correo. Intenta nuevamente.');
    setType('error');
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="recovery-container">
      <div className="recovery-card">
        <button className="back-button" onClick={() => navigate(-1)}>
          <ArrowLeft size={20} />
          <span>Regresar</span>
        </button>

        <div className="logo-section">
          <img src={logo} alt="Logo" className="company-logo" />
          <span>Recupera tu contraseña</span>
          <span>¿Olvidaste tu contraseña? tranqui, escribe tu correo y te enviaremos
        un enlace para que puedas restablecerla. Busca en la bandeja principal o en Spam</span>
        </div>

   
        

        <form onSubmit={handleReset}>
          <input
            type="email"
            placeholder="Correo electrónico"
            className="form-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          {message && (
            <p className={`message-text ${type === 'success' ? 'success' : 'error'}`}>{message}</p>
          )}

          <button type="submit" className="submit-button" disabled={loading}>
            {loading ? 'Enviando...' : 'Enviar enlace'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default PasswordRecovery;
